import { PermissionsEnum } from "@/auth/interfaces";
import {
  // EstadoFactibilidadCorporativaENUM,
  ROUTER_PATHS,
  TABLE_CONSTANTS,
} from "@/shared";
import { useFetchGetfactibilidadCorporativos } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import {
  useCheckPermissionsArray,
  useTableColumnsFactibilidadCorporativa,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared/hooks";
import {  } from "@/shared/interfaces";
import { IFactibilidadCorporativo } from "@/shared/interfaces/erp/factibilidad_corporativo";
import { Visibility } from "@mui/icons-material";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface TableSolicitudFactibilidadCorporativoProps {
  enableEditing?: boolean;
  estado_factibilidad?: string;
  // aceptado_factibilidad?: boolean;
  canEditGlobal?: boolean;

  //* 
  aceptado_factibilidad?: boolean
  preaprobado_inventario?: boolean
  aprobado_supervisor?: boolean
  aprobado_inventario?: boolean
}

export default function TableSolicitudFactibilidadCorporativo({
  enableEditing = true,
  estado_factibilidad,
  //aceptado_factibilidad,
  canEditGlobal = true,
  aceptado_factibilidad = false,
  preaprobado_inventario = false,
  aprobado_supervisor = false,
  aprobado_inventario = false
}: TableSolicitudFactibilidadCorporativoProps) {
  useCheckPermissionsArray([
    PermissionsEnum.api_view_factibilidadcoorporativa,
    PermissionsEnum.api_change_factibilidadcoorporativa,
  ]);

  const navigate = useNavigate();

  ///* Hook
  const { columnsFactibilidad } = useTableColumnsFactibilidadCorporativa();

  const { pagination, setPagination } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const {
    isLoading,
    data: dataFactibilidadCorporativa,
    isRefetching,
  } = useFetchGetfactibilidadCorporativos({
    page: pageIndex + 1,
    page_size: pageSize,
    ...filterObject,
    filterByState: false,
    estado_factibilidad_in: estado_factibilidad,
    //aceptado_factibilidad,
    aceptado_factibilidad,
    preaprobado_inventario,
    aprobado_supervisor,
    aprobado_inventario
  });

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}></Grid>
        <Grid item xs={12}>
          <GeneralTable<IFactibilidadCorporativo>
            columns={columnsFactibilidad}
            data={dataFactibilidadCorporativa?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataFactibilidadCorporativa?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            // // actions
            // crud
            canDelete={false}
            canEdit={false}
            positionActionsColumn="first"
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}
            enableEditing={canEditGlobal && enableEditing}
            showCustomActionBtnSpace={canEditGlobal}
            customActionBtnSpace={(value) => {
              return (
                <>
                  <Grid container>
                    <Grid item>
                      <Tooltip placement="top" title="Ver Solicitud">
                        <IconButton
                          onClick={() => {
                            navigate(
                              `${ROUTER_PATHS.inventario.revisarSolicitudFactibilidadCorporativoNav}/${value.id_factibilidad_coorporativa}`
                            );
                          }}
                        >
                          <Visibility />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </>
              );
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}
